export default __webpack_public_path__ + "static/media/googleSignInDarkButton.bfd57d53.svg";